import apiFetch from '../apiFetch'

export default function ({ nombre, nombreRaza, fechaExtraccion, idPool }) {
    return apiFetch({
        endPoint: `Pool/imprimirEtiquetasBolsas?idPool=${idPool}&nombre=${nombre}&nombreRaza=${nombreRaza}&fechaExtraccion=${fechaExtraccion}`,
        method: 'GET', body: null, token: null
    })
}
